import { render, staticRenderFns } from "./DriversPeriodsAvailableOverview.vue?vue&type=template&id=04ba4d66&scoped=true&"
import script from "./DriversPeriodsAvailableOverview.vue?vue&type=script&lang=js&"
export * from "./DriversPeriodsAvailableOverview.vue?vue&type=script&lang=js&"
import style0 from "./DriversPeriodsAvailableOverview.vue?vue&type=style&index=0&id=04ba4d66&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ba4d66",
  null
  
)

export default component.exports